enum OrderByDirections {
    ASC = "ASC",
    DESC = "DESC"
};

export default OrderByDirections;